const BtnResume = () => {
  return (
    <a
      href="/resume/resume.pdf"
      target="_blank"
      rel="noreferrer"
      className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium
            hover:shadow-lg hover:text-primary-500  hover:bg-background-light hover:shadow-primary-100 transition-all duration-300 inline-block"
    >
      Download My Resume
    </a>
  );
};
export default BtnResume;
